export default {"src":"/_next/static/media/sidebar-bottom.88456bbc.svg","height":44,"width":286,"blurWidth":0,"blurHeight":0};